import { validate } from "./functions"
import { FEATURE_FLAGS } from "./storage"

export function verifyFeatureFlag(requestFeatureFlag) {
  try {

    if(FEATURE_FLAGS() != '' && FEATURE_FLAGS()) {

      var features_flags = JSON.parse(FEATURE_FLAGS())

      let verifyExist = features_flags.find((featureFlag) => {
        return featureFlag.slug === requestFeatureFlag
      })

      return validate.exist(verifyExist)
    }

    return false;


  } catch (error) {

    console.log(error)

    return false;

  }


}
